export default "__VITE_ASSET__84dc7869__"